import React from "react"

const CustomerRegistryViewHero = ({ name, header_image, subheader_images }) => {
  return (
    <div className="registry__page-wrapper py-5 global-container mt-10">
      <div className="flex flex-wrap">
        <div className="mobiles:w-full w-2/5 lg:w-1/2 px-3 mb-4">
          <div className="registry__bannerImg">
            <img
              src={header_image}
              alt="lg_img"
              className="h-50vh object-center"
            />
          </div>
        </div>
        <div className="mobiles:w-full mobiles:px-2 w-3/5 lg:w-1/2 px-5 mb-4">
          <div
            className="registry__name-card mb-5  rounded-xl  text-center text-5xl"
            style={{ background: "#95D6A4", color: "white" }}
          >
            <div className="relative py-10 px-5">
              <p>
                <b>{name}</b>
              </p>
            </div>
          </div>
          <div className="registry__welcome text-center my-10">
            <h3 className="font-semibold text-2xl text-gray-600">
              Welcome to our registry
            </h3>
          </div>
          <div className="flex my-4 registry-mini-images">
            <div className="w-1/3 pr-2">
              <img
                src={header_image}
                alt="img_sm"
                className="h-20vh object-center w-full rounded-lg"
              />
            </div>
            <div className="w-1/3 px-2">
              <img
                src={
                  subheader_images?.length ? subheader_images[0] : header_image
                }
                alt="img_sm"
                className="h-20vh object-center w-full rounded-lg"
              />
            </div>
            <div className="w-1/3 pl-2">
              <img
                src={
                  subheader_images?.length ? subheader_images[1] : header_image
                }
                alt="img_sm"
                className="h-20vh object-center w-full rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerRegistryViewHero
